module.exports = "//public.getcloudapp.com/packs/media/images/cloudapp-icon-3f31e37ac5a1cbf082173a177e92af36.png";